import {
    GET_BALANCE_SHEET_REQUEST,
    GET_BALANCE_SHEET_SUCCESS,
    GET_BALANCE_SHEET_ERROR

} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_BALANCE_SHEET_REQUEST:
            return {
                loading: true,
            };
        case GET_BALANCE_SHEET_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_BALANCE_SHEET_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}